import { render, staticRenderFns } from "./partyCenter.vue?vue&type=template&id=28275296"
import script from "./partyCenter.vue?vue&type=script&lang=js"
export * from "./partyCenter.vue?vue&type=script&lang=js"
import style0 from "./partyCenter.vue?vue&type=style&index=0&id=28275296&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports